import {
  OdontogramTeethArchProps,
  getPieceColor,
  getPieceTextColor,
  showToothBorder
} from './odontogramTeethArchUtils';

export default function OdontogramLowerTeethArch(props: OdontogramTeethArchProps) {
  return (
    <svg width={327} height={267} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3236_7662)" onClick={() => props.onPieceClick('42')}>
        <path
          {...showToothBorder('42', props)}
          id="42"
          d="M122.98 259.551C119.522 258.446 113.896 256.551 110.254 254.829C106.974 253.277 103.066 250.474 100.347 248.38C98.4952 246.953 98.3338 244.26 99.9484 242.57C106.971 235.219 117.572 225.02 124.14 228.046C130.93 231.175 129.35 247.687 126.904 257.428C126.471 259.152 124.674 260.092 122.98 259.551Z"
          fill={`${getPieceColor('42', props)}`}
        />
      </g>
      <g filter="url(#filter1_d_3236_7662)" onClick={() => props.onPieceClick('41')}>
        <path
          {...showToothBorder('41', props)}
          id="41"
          d="M159.269 267.451C155.522 267.551 148.705 267.579 143.888 266.712C139.629 265.946 134.019 263.955 130.731 262.705C129.226 262.132 128.534 260.414 129.144 258.924C133.08 249.305 139.086 232.897 151.196 234.627C159.947 235.876 161.647 253.749 161.949 264.619C161.991 266.148 160.799 267.41 159.269 267.451Z"
          fill={`${getPieceColor('41', props)}`}
        />
      </g>
      <g filter="url(#filter2_d_3236_7662)" onClick={() => props.onPieceClick('43')}>
        <path
          {...showToothBorder('43', props)}
          id="43"
          d="M101.953 235.091C106.611 222.378 107.543 211.889 103.195 209.982C98.8479 208.075 80.8383 211.662 77.4227 223.649C75.6838 229.751 79.6998 235.621 82.3909 237.634C86.5311 241.024 97.2956 247.804 101.953 235.091Z"
          fill={`${getPieceColor('43', props)}`}
        />
      </g>
      <g filter="url(#filter3_d_3236_7662)" onClick={() => props.onPieceClick('44')}>
        <path
          {...showToothBorder('44', props)}
          id="44"
          d="M86.0373 207.597C90.8098 200.387 91.4457 191.61 86.9913 187.535C82.5368 183.459 72.674 185.967 65.9923 190.983C58.0476 196.947 58.585 207.181 64.1977 211.888C69.8104 216.595 81.2647 214.807 86.0373 207.597Z"
          fill={`${getPieceColor('44', props)}`}
        />
        <g filter="url(#filter4_f_3236_7662)">
          <path
            d="M74.4991 196.548C74.9927 199.197 78.7916 202.344 81.2813 203.689C82.7408 204.435 81.8823 205.759 79.5643 204.911C78.1478 204.352 77.9117 205.946 77.0532 207.208C75.6366 209.279 74.9069 208.802 75.98 206.194C76.3375 205.332 76.5095 204.408 76.4856 203.48C76.4616 202.552 76.2423 201.638 75.8408 200.793C75.4393 199.949 74.8641 199.193 74.1501 198.57C73.4362 197.946 72.5983 197.47 71.6874 197.169C68.425 196.175 68.5967 194.974 69.7772 194.809C70.9577 194.643 72.3742 196.113 74.0698 193.318C74.9927 191.807 76.0659 192.615 75.2932 193.919C74.7995 194.871 74.2844 195.388 74.4991 196.548Z"
            fill={`${getPieceColor('44', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter5_d_3236_7662)" onClick={() => props.onPieceClick('45')}>
        <path
          {...showToothBorder('45', props)}
          id="45"
          d="M72.9249 182.241C79.2182 175.541 82.95 168.131 79.4726 162.824C75.9952 157.517 61.9258 157.354 54.668 161.588C46.0382 166.622 41.4622 174.545 47.1029 183.819C52.7435 193.093 66.6315 188.941 72.9249 182.241Z"
          fill={`${getPieceColor('45', props)}`}
        />
        <g filter="url(#filter6_f_3236_7662)">
          <path
            d="M65.5032 179.213C64.0669 178.711 63.0746 178.605 62.1345 177.257C61.3019 175.642 60.7988 173.873 60.6553 172.057C60.5117 170.24 60.7306 168.413 61.2989 166.684C61.7689 165.283 60.0193 164.86 58.9748 166.896C58.3481 168.164 56.9118 167.16 55.2928 166.896C52.6814 166.288 50.5662 167.847 53.2298 169.01C59.6537 171.865 60.7505 175.988 59.0792 179.081C56.9901 182.888 58.2958 184.103 59.5754 183.231C60.855 182.359 60.6983 179.61 65.0593 181.117C67.5401 181.857 67.5923 180.059 65.5032 179.213Z"
            fill={`${getPieceColor('45', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter7_d_3236_7662)" onClick={() => props.onPieceClick('46')}>
        <path
          {...showToothBorder('46', props)}
          id="46"
          d="M43.4424 158.133C55.2441 163.851 80.7967 143.676 71.1347 122.993C65.0625 109.994 42.4326 112.186 34.4744 120.733C28.0432 127.639 30.0317 138.05 34.4986 141.646C38.9655 145.242 31.6407 152.416 43.4424 158.133Z"
          fill={`${getPieceColor('46', props)}`}
        />
        <g filter="url(#filter8_f_3236_7662)">
          <path
            d="M39.0811 138.425C38.3468 136.255 42.7872 135.87 44.8501 134.925C49.1857 132.755 50.6192 128.1 49.4304 122.5C51.0388 124.635 51.8779 129.115 53.2415 129.955C56.9477 132.23 69.9194 126.455 58.2064 133C51.5982 136.815 56.668 141.085 53.5911 143.5C47.7172 134.085 39.6055 139.65 39.0811 138.425Z"
            fill={`${getPieceColor('46', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter9_d_3236_7662)" onClick={() => props.onPieceClick('48')}>
        <path
          {...showToothBorder('48', props)}
          id="48"
          d="M36.3614 67.5195C49.691 66.3747 57.4042 55.3615 58.3649 41.3161C59.3255 27.2707 32.022 27.3084 26.0558 29.8701C20.0895 32.4318 19.884 36.7599 18.1936 42.0099C16.6365 46.846 13.7918 48.0805 15.0346 57.3351C16.2774 66.5897 26.9596 68.327 36.3614 67.5195Z"
          fill={`${getPieceColor('48', props)}`}
        />
        <g filter="url(#filter10_f_3236_7662)">
          <path
            d="M25.8424 57.9075C34.692 54.3177 34.095 49.7588 31.3207 47.7126C29.3892 46.3127 27.809 48.1075 25.6668 48.0357C24.2621 48.0357 23.4193 46.6357 24.4728 45.7742C25.8041 45.1103 27.191 44.5696 28.6167 44.1588C30.1267 42.3639 27.6334 40.246 26.5096 38.0563C25.0698 35.1845 27.0013 33.3178 28.9678 35.364C32.4796 38.9537 31.5314 42.7588 35.9913 38.6306C42.6987 32.1691 47.4746 36.3691 40.697 40.1383C36.2371 42.6152 33.6736 55.6818 41.3994 55.4305C43.7522 55.4305 44.5599 57.3331 43.6117 58.6972C41.6452 61.5331 37.7472 57.2613 34.7973 57.5485C32.5147 57.7639 31.0398 60.2049 29.1083 61.1382C26.0531 62.61 22.3307 59.1998 25.8424 57.9075Z"
            fill={`${getPieceColor('48', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter11_d_3236_7662)" onClick={() => props.onPieceClick('47')}>
        <path
          {...showToothBorder('47', props)}
          id="47"
          d="M21.5343 93.7767C20.0958 101.404 19.0169 107.124 25.9738 110.944C32.9313 114.764 52.8406 109.058 57.8927 101.751C62.9448 94.444 61.9921 89.0393 60.7227 82.9985C59.4532 76.9577 55.0234 71.5502 49.3329 70.2741C43.6423 68.998 35.1088 70.8983 26.893 74.0705C18.6772 77.2426 22.9734 86.1467 21.5347 93.7746L21.5343 93.7767Z"
          fill={`${getPieceColor('47', props)}`}
        />
        <g filter="url(#filter12_f_3236_7662)">
          <path
            d="M36.2117 94.1189C40.057 92.8881 39.0601 88.1152 33.5628 86.2541C29.5751 84.9633 31.455 80.0103 33.3064 82.5018C39.0031 90.0964 39.0031 79.5 42.7915 79.5C44.3296 79.5 45.1271 80.4606 41.7091 84.2129C40.9726 84.9008 40.4596 85.8151 40.2425 86.8268C40.0253 87.8384 40.115 88.8964 40.4989 89.8514C40.8828 90.8065 41.5415 91.6104 42.3821 92.1499C43.2227 92.6893 44.2028 92.937 45.1841 92.8581C47.6337 93.0983 47.5767 95.8599 45.1841 96.1301C43.4751 96.3402 41.4528 95.8299 41.3103 97.8111C41.0255 102.134 40.3134 102.854 38.462 98.9218C37.0663 96.3402 23.9068 98.0513 36.2117 94.1189Z"
            fill={`${getPieceColor('47', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter13_d_3236_7662)" onClick={() => props.onPieceClick('32')}>
        <path
          {...showToothBorder('32', props)}
          id="32"
          d="M205.02 259.551C208.478 258.446 214.104 256.551 217.746 254.829C221.026 253.277 224.934 250.474 227.653 248.38C229.505 246.953 229.666 244.26 228.052 242.57C221.029 235.219 210.428 225.02 203.86 228.046C197.07 231.175 198.65 247.687 201.096 257.428C201.529 259.152 203.326 260.092 205.02 259.551Z"
          fill={`${getPieceColor('32', props)}`}
        />
      </g>
      <g filter="url(#filter14_d_3236_7662)" onClick={() => props.onPieceClick('31')}>
        <path
          {...showToothBorder('31', props)}
          id="31"
          d="M168.731 267.451C172.478 267.551 179.295 267.579 184.112 266.712C188.371 265.946 193.981 263.955 197.269 262.705C198.774 262.132 199.466 260.414 198.856 258.924C194.92 249.305 188.914 232.897 176.804 234.627C168.053 235.876 166.353 253.749 166.051 264.619C166.009 266.148 167.201 267.41 168.731 267.451Z"
          fill={`${getPieceColor('31', props)}`}
        />
      </g>
      <g filter="url(#filter15_d_3236_7662)" onClick={() => props.onPieceClick('33')}>
        <path
          {...showToothBorder('33', props)}
          id="33"
          d="M226.047 235.091C221.389 222.378 220.457 211.889 224.805 209.982C229.152 208.075 247.162 211.662 250.577 223.649C252.316 229.751 248.3 235.621 245.609 237.634C241.469 241.024 230.704 247.804 226.047 235.091Z"
          fill={`${getPieceColor('33', props)}`}
        />
      </g>
      <g filter="url(#filter16_d_3236_7662)" onClick={() => props.onPieceClick('34')}>
        <path
          {...showToothBorder('34', props)}
          id="34"
          d="M241.963 207.597C237.19 200.387 236.554 191.61 241.009 187.535C245.463 183.459 255.326 185.967 262.008 190.983C269.952 196.947 269.415 207.181 263.802 211.888C258.19 216.595 246.735 214.807 241.963 207.597Z"
          fill={`${getPieceColor('34', props)}`}
        />
        <g filter="url(#filter17_f_3236_7662)">
          <path
            d="M253.501 196.548C253.007 199.197 249.208 202.344 246.719 203.689C245.259 204.435 246.118 205.759 248.436 204.911C249.852 204.352 250.088 205.946 250.947 207.208C252.363 209.279 253.093 208.802 252.02 206.194C251.662 205.332 251.49 204.408 251.514 203.48C251.538 202.552 251.758 201.638 252.159 200.793C252.561 199.949 253.136 199.193 253.85 198.57C254.564 197.946 255.402 197.47 256.313 197.169C259.575 196.175 259.403 194.974 258.223 194.809C257.042 194.643 255.626 196.113 253.93 193.318C253.007 191.807 251.934 192.615 252.707 193.919C253.2 194.871 253.716 195.388 253.501 196.548Z"
            fill={`${getPieceColor('34', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter18_d_3236_7662)" onClick={() => props.onPieceClick('35')}>
        <path
          {...showToothBorder('35', props)}
          id="35"
          d="M255.075 182.241C248.782 175.541 245.05 168.131 248.527 162.824C252.005 157.517 266.074 157.354 273.332 161.588C281.962 166.622 286.538 174.545 280.897 183.819C275.257 193.093 261.369 188.941 255.075 182.241Z"
          fill={`${getPieceColor('35', props)}`}
        />
        <g filter="url(#filter19_f_3236_7662)">
          <path
            d="M262.497 179.213C263.933 178.711 264.925 178.605 265.865 177.257C266.698 175.642 267.201 173.873 267.345 172.057C267.488 170.24 267.269 168.413 266.701 166.684C266.231 165.283 267.981 164.86 269.025 166.896C269.652 168.164 271.088 167.16 272.707 166.896C275.319 166.288 277.434 167.847 274.77 169.01C268.346 171.865 267.25 175.988 268.921 179.081C271.01 182.888 269.704 184.103 268.425 183.231C267.145 182.359 267.302 179.61 262.941 181.117C260.46 181.857 260.408 180.059 262.497 179.213Z"
            fill={`${getPieceColor('35', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter20_d_3236_7662)" onClick={() => props.onPieceClick('36')}>
        <path
          {...showToothBorder('36', props)}
          id="36"
          d="M284.558 158.133C272.756 163.851 247.203 143.676 256.865 122.993C262.938 109.994 285.567 112.186 293.526 120.733C299.957 127.639 297.968 138.05 293.501 141.646C289.035 145.242 296.359 152.416 284.558 158.133Z"
          fill={`${getPieceColor('36', props)}`}
        />
        <g filter="url(#filter21_f_3236_7662)">
          <path
            d="M288.919 138.425C289.653 136.255 285.213 135.87 283.15 134.925C278.814 132.755 277.381 128.1 278.57 122.5C276.961 124.635 276.122 129.115 274.758 129.955C271.052 132.23 258.081 126.455 269.794 133C276.402 136.815 271.332 141.085 274.409 143.5C280.283 134.085 288.394 139.65 288.919 138.425Z"
            fill={`${getPieceColor('36', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter22_d_3236_7662)" onClick={() => props.onPieceClick('38')}>
        <path
          {...showToothBorder('38', props)}
          id="38"
          d="M291.639 67.5195C278.309 66.3747 270.596 55.3615 269.635 41.3161C268.675 27.2707 295.978 27.3084 301.944 29.8701C307.91 32.4318 308.116 36.7599 309.806 42.0099C311.363 46.846 314.208 48.0805 312.965 57.3351C311.723 66.5897 301.04 68.327 291.639 67.5195Z"
          fill={`${getPieceColor('38', props)}`}
        />
        <g filter="url(#filter23_f_3236_7662)">
          <path
            d="M302.158 57.9075C293.308 54.3177 293.905 49.7588 296.679 47.7126C298.611 46.3127 300.191 48.1075 302.333 48.0357C303.738 48.0357 304.581 46.6357 303.527 45.7742C302.196 45.1103 300.809 44.5696 299.383 44.1588C297.873 42.3639 300.367 40.246 301.49 38.0563C302.93 35.1845 300.999 33.3178 299.032 35.364C295.52 38.9537 296.469 42.7588 292.009 38.6306C285.301 32.1691 280.525 36.3691 287.303 40.1383C291.763 42.6152 294.326 55.6818 286.601 55.4305C284.248 55.4305 283.44 57.3331 284.388 58.6972C286.355 61.5331 290.253 57.2613 293.203 57.5485C295.485 57.7639 296.96 60.2049 298.892 61.1382C301.947 62.61 305.669 59.1998 302.158 57.9075Z"
            fill={`${getPieceColor('38', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter24_d_3236_7662)" onClick={() => props.onPieceClick('37')}>
        <path
          {...showToothBorder('37', props)}
          id="37"
          d="M306.466 93.7767C307.904 101.404 308.983 107.124 302.026 110.944C295.069 114.764 275.159 109.058 270.107 101.751C265.055 94.444 266.008 89.0393 267.277 82.9985C268.547 76.9577 272.977 71.5502 278.667 70.2741C284.358 68.998 292.891 70.8983 301.107 74.0705C309.323 77.2426 305.027 86.1467 306.465 93.7746L306.466 93.7767Z"
          fill={`${getPieceColor('37', props)}`}
        />
        <g filter="url(#filter25_f_3236_7662)">
          <path
            d="M291.788 94.1189C287.943 92.8881 288.94 88.1152 294.437 86.2541C298.425 84.9633 296.545 80.0103 294.694 82.5018C288.997 90.0964 288.997 79.5 285.209 79.5C283.67 79.5 282.873 80.4606 286.291 84.2129C287.027 84.9008 287.54 85.8151 287.758 86.8268C287.975 87.8384 287.885 88.8964 287.501 89.8514C287.117 90.8065 286.458 91.6104 285.618 92.1499C284.777 92.6893 283.797 92.937 282.816 92.8581C280.366 93.0983 280.423 95.8599 282.816 96.1301C284.525 96.3402 286.547 95.8299 286.69 97.8111C286.975 102.134 287.687 102.854 289.538 98.9218C290.934 96.3402 304.093 98.0513 291.788 94.1189Z"
            fill={`${getPieceColor('37', props, true)}`}
            fillOpacity="0.1"
          />
        </g>
      </g>
      <path
        d="M26.8097 48.394V47.406L31.5157 41.27H32.7897V47.367H34.1417V48.394H32.7897V50.5H31.5937V48.394H26.8097ZM31.6717 42.713L28.0577 47.367H31.6717V42.713ZM35.3913 43.493C35.3913 43.0423 35.5126 42.6307 35.7553 42.258C35.9979 41.8853 36.3576 41.5907 36.8343 41.374C37.3109 41.1573 37.8786 41.049 38.5373 41.049C39.1959 41.049 39.7593 41.1573 40.2273 41.374C40.7039 41.5907 41.0636 41.8853 41.3063 42.258C41.5489 42.6307 41.6703 43.0423 41.6703 43.493C41.6703 44.0043 41.5316 44.4463 41.2543 44.819C40.9769 45.1917 40.5566 45.456 39.9933 45.612C40.5999 45.7767 41.0723 46.0627 41.4103 46.47C41.7483 46.8773 41.9173 47.38 41.9173 47.978C41.9173 48.8447 41.6096 49.525 40.9943 50.019C40.3789 50.513 39.5599 50.76 38.5373 50.76C37.5146 50.76 36.6956 50.513 36.0803 50.019C35.4649 49.525 35.1573 48.8447 35.1573 47.978C35.1573 47.38 35.3219 46.8773 35.6513 46.47C35.9893 46.0627 36.4616 45.7767 37.0683 45.612C36.5049 45.456 36.0846 45.1917 35.8073 44.819C35.5299 44.4463 35.3913 44.0043 35.3913 43.493ZM36.5613 43.662C36.5613 44.182 36.7389 44.585 37.0943 44.871C37.4496 45.1483 37.9306 45.287 38.5373 45.287C39.1439 45.287 39.6206 45.1483 39.9673 44.871C40.3226 44.585 40.5003 44.182 40.5003 43.662C40.5003 43.142 40.3226 42.7433 39.9673 42.466C39.6119 42.18 39.1353 42.037 38.5373 42.037C37.9393 42.037 37.4583 42.18 37.0943 42.466C36.7389 42.7433 36.5613 43.142 36.5613 43.662ZM36.3143 47.913C36.3143 48.5023 36.5136 48.9617 36.9123 49.291C37.3109 49.6117 37.8526 49.772 38.5373 49.772C39.2133 49.772 39.7506 49.6073 40.1493 49.278C40.5479 48.9487 40.7473 48.4937 40.7473 47.913C40.7473 47.3237 40.5393 46.8773 40.1233 46.574C39.7073 46.2707 39.1786 46.119 38.5373 46.119C37.8873 46.119 37.3543 46.2707 36.9383 46.574C36.5223 46.8773 36.3143 47.3237 36.3143 47.913Z"
        fill={getPieceTextColor('48', props)}
        onClick={() => props.onPieceClick('48')}
      />
      <path
        d="M285.497 41.088C286.086 41.088 286.593 41.192 287.018 41.4C287.443 41.608 287.763 41.894 287.98 42.258C288.197 42.622 288.305 43.0337 288.305 43.493C288.305 44.065 288.136 44.546 287.798 44.936C287.469 45.326 286.983 45.56 286.342 45.638V45.716C287.009 45.8893 287.529 46.158 287.902 46.522C288.283 46.886 288.474 47.3887 288.474 48.03C288.474 48.784 288.223 49.3993 287.72 49.876C287.217 50.3527 286.494 50.591 285.549 50.591C284.604 50.591 283.837 50.3483 283.248 49.863C282.667 49.369 282.325 48.6497 282.221 47.705H283.391C283.469 48.277 283.686 48.732 284.041 49.07C284.405 49.408 284.895 49.577 285.51 49.577C286.091 49.577 286.537 49.4297 286.849 49.135C287.161 48.8317 287.317 48.4417 287.317 47.965C287.317 47.393 287.092 46.9597 286.641 46.665C286.199 46.3617 285.566 46.21 284.743 46.21H284.431V45.222H284.743C286.338 45.222 287.135 44.689 287.135 43.623C287.135 43.155 286.988 42.7823 286.693 42.505C286.398 42.2277 285.991 42.089 285.471 42.089C284.951 42.089 284.513 42.2407 284.158 42.544C283.803 42.8387 283.595 43.2763 283.534 43.857H282.377C282.438 42.9903 282.737 42.3143 283.274 41.829C283.82 41.335 284.561 41.088 285.497 41.088ZM290.188 43.493C290.188 43.0423 290.309 42.6307 290.552 42.258C290.795 41.8853 291.154 41.5907 291.631 41.374C292.108 41.1573 292.675 41.049 293.334 41.049C293.993 41.049 294.556 41.1573 295.024 41.374C295.501 41.5907 295.86 41.8853 296.103 42.258C296.346 42.6307 296.467 43.0423 296.467 43.493C296.467 44.0043 296.328 44.4463 296.051 44.819C295.774 45.1917 295.353 45.456 294.79 45.612C295.397 45.7767 295.869 46.0627 296.207 46.47C296.545 46.8773 296.714 47.38 296.714 47.978C296.714 48.8447 296.406 49.525 295.791 50.019C295.176 50.513 294.357 50.76 293.334 50.76C292.311 50.76 291.492 50.513 290.877 50.019C290.262 49.525 289.954 48.8447 289.954 47.978C289.954 47.38 290.119 46.8773 290.448 46.47C290.786 46.0627 291.258 45.7767 291.865 45.612C291.302 45.456 290.881 45.1917 290.604 44.819C290.327 44.4463 290.188 44.0043 290.188 43.493ZM291.358 43.662C291.358 44.182 291.536 44.585 291.891 44.871C292.246 45.1483 292.727 45.287 293.334 45.287C293.941 45.287 294.417 45.1483 294.764 44.871C295.119 44.585 295.297 44.182 295.297 43.662C295.297 43.142 295.119 42.7433 294.764 42.466C294.409 42.18 293.932 42.037 293.334 42.037C292.736 42.037 292.255 42.18 291.891 42.466C291.536 42.7433 291.358 43.142 291.358 43.662ZM291.111 47.913C291.111 48.5023 291.31 48.9617 291.709 49.291C292.108 49.6117 292.649 49.772 293.334 49.772C294.01 49.772 294.547 49.6073 294.946 49.278C295.345 48.9487 295.544 48.4937 295.544 47.913C295.544 47.3237 295.336 46.8773 294.92 46.574C294.504 46.2707 293.975 46.119 293.334 46.119C292.684 46.119 292.151 46.2707 291.735 46.574C291.319 46.8773 291.111 47.3237 291.111 47.913Z"
        fill={getPieceTextColor('38', props)}
        onClick={() => props.onPieceClick('38')}
      />
      <path
        d="M31.5842 94.394V93.406L36.2902 87.27H37.5642V93.367H38.9162V94.394H37.5642V96.5H36.3682V94.394H31.5842ZM36.4462 88.713L32.8322 93.367H36.4462V88.713ZM45.4307 88.193L41.9597 96.5H40.7117L44.2347 88.31H39.4247V87.283H45.4307V88.193Z"
        fill={getPieceTextColor('47', props)}
        onClick={() => props.onPieceClick('47')}
      />
      <path
        d="M281.271 87.088C281.861 87.088 282.368 87.192 282.792 87.4C283.217 87.608 283.538 87.894 283.754 88.258C283.971 88.622 284.079 89.0337 284.079 89.493C284.079 90.065 283.91 90.546 283.572 90.936C283.243 91.326 282.758 91.56 282.116 91.638V91.716C282.784 91.8893 283.304 92.158 283.676 92.522C284.058 92.886 284.248 93.3887 284.248 94.03C284.248 94.784 283.997 95.3993 283.494 95.876C282.992 96.3527 282.268 96.591 281.323 96.591C280.379 96.591 279.612 96.3483 279.022 95.863C278.442 95.369 278.099 94.6497 277.995 93.705H279.165C279.243 94.277 279.46 94.732 279.815 95.07C280.179 95.408 280.669 95.577 281.284 95.577C281.865 95.577 282.311 95.4297 282.623 95.135C282.935 94.8317 283.091 94.4417 283.091 93.965C283.091 93.393 282.866 92.9597 282.415 92.665C281.973 92.3617 281.341 92.21 280.517 92.21H280.205V91.222H280.517C282.112 91.222 282.909 90.689 282.909 89.623C282.909 89.155 282.762 88.7823 282.467 88.505C282.173 88.2277 281.765 88.089 281.245 88.089C280.725 88.089 280.288 88.2407 279.932 88.544C279.577 88.8387 279.369 89.2763 279.308 89.857H278.151C278.212 88.9903 278.511 88.3143 279.048 87.829C279.594 87.335 280.335 87.088 281.271 87.088ZM291.228 88.193L287.757 96.5H286.509L290.032 88.31H285.222V87.283H291.228V88.193Z"
        fill={getPieceTextColor('37', props)}
        onClick={() => props.onPieceClick('37')}
      />
      <path
        d="M41.8351 137.394V136.406L46.5411 130.27H47.8151V136.367H49.1671V137.394H47.8151V139.5H46.6191V137.394H41.8351ZM46.6971 131.713L43.0831 136.367H46.6971V131.713ZM55.4087 132.779C55.3393 132.233 55.153 131.813 54.8497 131.518C54.555 131.215 54.1433 131.063 53.6147 131.063C52.878 131.063 52.319 131.349 51.9377 131.921C51.565 132.493 51.3787 133.399 51.3787 134.638L51.3917 135.119C51.5217 134.599 51.8207 134.187 52.2887 133.884C52.7567 133.572 53.307 133.416 53.9397 133.416C54.8497 133.416 55.5603 133.689 56.0717 134.235C56.5917 134.781 56.8517 135.544 56.8517 136.523C56.8517 137.095 56.739 137.615 56.5137 138.083C56.2883 138.542 55.9417 138.911 55.4737 139.188C55.0143 139.457 54.4423 139.591 53.7577 139.591C52.449 139.591 51.5477 139.179 51.0537 138.356C50.5683 137.533 50.3257 136.415 50.3257 135.002C50.3257 133.373 50.5857 132.151 51.1057 131.336C51.6343 130.513 52.4923 130.101 53.6797 130.101C54.555 130.101 55.2267 130.348 55.6947 130.842C56.1713 131.336 56.453 131.982 56.5397 132.779H55.4087ZM51.5217 136.328C51.5217 136.961 51.7037 137.494 52.0677 137.927C52.4403 138.352 52.995 138.564 53.7317 138.564C54.3383 138.564 54.8237 138.386 55.1877 138.031C55.5517 137.667 55.7337 137.16 55.7337 136.51C55.7337 135.808 55.5517 135.275 55.1877 134.911C54.8237 134.538 54.321 134.352 53.6797 134.352C53.3157 134.352 52.969 134.426 52.6397 134.573C52.3103 134.72 52.0417 134.946 51.8337 135.249C51.6257 135.544 51.5217 135.903 51.5217 136.328Z"
        fill={getPieceTextColor('46', props)}
        onClick={() => props.onPieceClick('46')}
      />
      <path
        d="M271.522 130.088C272.112 130.088 272.619 130.192 273.043 130.4C273.468 130.608 273.789 130.894 274.005 131.258C274.222 131.622 274.33 132.034 274.33 132.493C274.33 133.065 274.161 133.546 273.823 133.936C273.494 134.326 273.009 134.56 272.367 134.638V134.716C273.035 134.889 273.555 135.158 273.927 135.522C274.309 135.886 274.499 136.389 274.499 137.03C274.499 137.784 274.248 138.399 273.745 138.876C273.243 139.353 272.519 139.591 271.574 139.591C270.63 139.591 269.863 139.348 269.273 138.863C268.693 138.369 268.35 137.65 268.246 136.705H269.416C269.494 137.277 269.711 137.732 270.066 138.07C270.43 138.408 270.92 138.577 271.535 138.577C272.116 138.577 272.562 138.43 272.874 138.135C273.186 137.832 273.342 137.442 273.342 136.965C273.342 136.393 273.117 135.96 272.666 135.665C272.224 135.362 271.592 135.21 270.768 135.21H270.456V134.222H270.768C272.363 134.222 273.16 133.689 273.16 132.623C273.16 132.155 273.013 131.782 272.718 131.505C272.424 131.228 272.016 131.089 271.496 131.089C270.976 131.089 270.539 131.241 270.183 131.544C269.828 131.839 269.62 132.276 269.559 132.857H268.402C268.463 131.99 268.762 131.314 269.299 130.829C269.845 130.335 270.586 130.088 271.522 130.088ZM281.206 132.779C281.136 132.233 280.95 131.813 280.647 131.518C280.352 131.215 279.94 131.063 279.412 131.063C278.675 131.063 278.116 131.349 277.735 131.921C277.362 132.493 277.176 133.399 277.176 134.638L277.189 135.119C277.319 134.599 277.618 134.187 278.086 133.884C278.554 133.572 279.104 133.416 279.737 133.416C280.647 133.416 281.357 133.689 281.869 134.235C282.389 134.781 282.649 135.544 282.649 136.523C282.649 137.095 282.536 137.615 282.311 138.083C282.085 138.542 281.739 138.911 281.271 139.188C280.811 139.457 280.239 139.591 279.555 139.591C278.246 139.591 277.345 139.179 276.851 138.356C276.365 137.533 276.123 136.415 276.123 135.002C276.123 133.373 276.383 132.151 276.903 131.336C277.431 130.513 278.289 130.101 279.477 130.101C280.352 130.101 281.024 130.348 281.492 130.842C281.968 131.336 282.25 131.982 282.337 132.779H281.206ZM277.319 136.328C277.319 136.961 277.501 137.494 277.865 137.927C278.237 138.352 278.792 138.564 279.529 138.564C280.135 138.564 280.621 138.386 280.985 138.031C281.349 137.667 281.531 137.16 281.531 136.51C281.531 135.808 281.349 135.275 280.985 134.911C280.621 134.538 280.118 134.352 279.477 134.352C279.113 134.352 278.766 134.426 278.437 134.573C278.107 134.72 277.839 134.946 277.631 135.249C277.423 135.544 277.319 135.903 277.319 136.328Z"
        fill={getPieceTextColor('36', props)}
        onClick={() => props.onPieceClick('36')}
      />
      <path
        d="M53.8669 177.394V176.406L58.5729 170.27H59.8469V176.367H61.1989V177.394H59.8469V179.5H58.6509V177.394H53.8669ZM58.7289 171.713L55.1149 176.367H58.7289V171.713ZM68.4414 171.271H63.7354V174.339C63.9521 174.044 64.2641 173.81 64.6714 173.637C65.0787 173.464 65.5251 173.377 66.0104 173.377C66.6604 173.377 67.1977 173.516 67.6224 173.793C68.0557 174.062 68.3721 174.421 68.5714 174.872C68.7794 175.314 68.8834 175.808 68.8834 176.354C68.8834 177.299 68.6191 178.07 68.0904 178.668C67.5617 179.266 66.7861 179.565 65.7634 179.565C64.8447 179.565 64.0951 179.318 63.5144 178.824C62.9337 178.321 62.6087 177.65 62.5394 176.809H63.7094C63.8047 177.346 64.0257 177.767 64.3724 178.07C64.7277 178.365 65.1741 178.512 65.7114 178.512C66.3787 178.512 66.8814 178.313 67.2194 177.914C67.5574 177.515 67.7264 176.991 67.7264 176.341C67.7264 175.708 67.5531 175.214 67.2064 174.859C66.8597 174.504 66.3701 174.326 65.7374 174.326C65.2867 174.326 64.8924 174.426 64.5544 174.625C64.2164 174.816 63.9607 175.076 63.7874 175.405H62.6434V170.218H68.4414V171.271Z"
        fill={getPieceTextColor('45', props)}
        onClick={() => props.onPieceClick('45')}
      />
      <path
        d="M261.554 170.088C262.143 170.088 262.65 170.192 263.075 170.4C263.5 170.608 263.82 170.894 264.037 171.258C264.254 171.622 264.362 172.034 264.362 172.493C264.362 173.065 264.193 173.546 263.855 173.936C263.526 174.326 263.04 174.56 262.399 174.638V174.716C263.066 174.889 263.586 175.158 263.959 175.522C264.34 175.886 264.531 176.389 264.531 177.03C264.531 177.784 264.28 178.399 263.777 178.876C263.274 179.353 262.551 179.591 261.606 179.591C260.661 179.591 259.894 179.348 259.305 178.863C258.724 178.369 258.382 177.65 258.278 176.705H259.448C259.526 177.277 259.743 177.732 260.098 178.07C260.462 178.408 260.952 178.577 261.567 178.577C262.148 178.577 262.594 178.43 262.906 178.135C263.218 177.832 263.374 177.442 263.374 176.965C263.374 176.393 263.149 175.96 262.698 175.665C262.256 175.362 261.623 175.21 260.8 175.21H260.488V174.222H260.8C262.395 174.222 263.192 173.689 263.192 172.623C263.192 172.155 263.045 171.782 262.75 171.505C262.455 171.228 262.048 171.089 261.528 171.089C261.008 171.089 260.57 171.241 260.215 171.544C259.86 171.839 259.652 172.276 259.591 172.857H258.434C258.495 171.99 258.794 171.314 259.331 170.829C259.877 170.335 260.618 170.088 261.554 170.088ZM272.238 171.271H267.532V174.339C267.749 174.044 268.061 173.81 268.468 173.637C268.876 173.464 269.322 173.377 269.807 173.377C270.457 173.377 270.995 173.516 271.419 173.793C271.853 174.062 272.169 174.421 272.368 174.872C272.576 175.314 272.68 175.808 272.68 176.354C272.68 177.299 272.416 178.07 271.887 178.668C271.359 179.266 270.583 179.565 269.56 179.565C268.642 179.565 267.892 179.318 267.311 178.824C266.731 178.321 266.406 177.65 266.336 176.809H267.506C267.602 177.346 267.823 177.767 268.169 178.07C268.525 178.365 268.971 178.512 269.508 178.512C270.176 178.512 270.678 178.313 271.016 177.914C271.354 177.515 271.523 176.991 271.523 176.341C271.523 175.708 271.35 175.214 271.003 174.859C270.657 174.504 270.167 174.326 269.534 174.326C269.084 174.326 268.689 174.426 268.351 174.625C268.013 174.816 267.758 175.076 267.584 175.405H266.44V170.218H272.238V171.271Z"
        fill={getPieceTextColor('35', props)}
        onClick={() => props.onPieceClick('35')}
      />
      <path
        d="M65.8415 204.394V203.406L70.5475 197.27H71.8215V203.367H73.1735V204.394H71.8215V206.5H70.6255V204.394H65.8415ZM70.7035 198.713L67.0895 203.367H70.7035V198.713ZM73.903 204.394V203.406L78.609 197.27H79.883V203.367H81.235V204.394H79.883V206.5H78.687V204.394H73.903ZM78.765 198.713L75.151 203.367H78.765V198.713Z"
        fill={getPieceTextColor('44', props)}
        onClick={() => props.onPieceClick('44')}
      />
      <path
        d="M248.529 197.088C249.118 197.088 249.625 197.192 250.05 197.4C250.474 197.608 250.795 197.894 251.012 198.258C251.228 198.622 251.337 199.034 251.337 199.493C251.337 200.065 251.168 200.546 250.83 200.936C250.5 201.326 250.015 201.56 249.374 201.638V201.716C250.041 201.889 250.561 202.158 250.934 202.522C251.315 202.886 251.506 203.389 251.506 204.03C251.506 204.784 251.254 205.399 250.752 205.876C250.249 206.353 249.525 206.591 248.581 206.591C247.636 206.591 246.869 206.348 246.28 205.863C245.699 205.369 245.357 204.65 245.253 203.705H246.423C246.501 204.277 246.717 204.732 247.073 205.07C247.437 205.408 247.926 205.577 248.542 205.577C249.122 205.577 249.569 205.43 249.881 205.135C250.193 204.832 250.349 204.442 250.349 203.965C250.349 203.393 250.123 202.96 249.673 202.665C249.231 202.362 248.598 202.21 247.775 202.21H247.463V201.222H247.775C249.369 201.222 250.167 200.689 250.167 199.623C250.167 199.155 250.019 198.782 249.725 198.505C249.43 198.228 249.023 198.089 248.503 198.089C247.983 198.089 247.545 198.241 247.19 198.544C246.834 198.839 246.626 199.276 246.566 199.857H245.409C245.469 198.99 245.768 198.314 246.306 197.829C246.852 197.335 247.593 197.088 248.529 197.088ZM252.7 204.394V203.406L257.406 197.27H258.68V203.367H260.032V204.394H258.68V206.5H257.484V204.394H252.7ZM257.562 198.713L253.948 203.367H257.562V198.713Z"
        fill={getPieceTextColor('34', props)}
        onClick={() => props.onPieceClick('34')}
      />
      <path
        d="M84.0446 232.394V231.406L88.7506 225.27H90.0246V231.367H91.3766V232.394H90.0246V234.5H88.8286V232.394H84.0446ZM88.9066 226.713L85.2926 231.367H88.9066V226.713ZM95.5901 225.088C96.1795 225.088 96.6865 225.192 97.1111 225.4C97.5358 225.608 97.8565 225.894 98.0731 226.258C98.2898 226.622 98.3981 227.034 98.3981 227.493C98.3981 228.065 98.2291 228.546 97.8911 228.936C97.5618 229.326 97.0765 229.56 96.4351 229.638V229.716C97.1025 229.889 97.6225 230.158 97.9951 230.522C98.3765 230.886 98.5671 231.389 98.5671 232.03C98.5671 232.784 98.3158 233.399 97.8131 233.876C97.3105 234.353 96.5868 234.591 95.6421 234.591C94.6975 234.591 93.9305 234.348 93.3411 233.863C92.7605 233.369 92.4181 232.65 92.3141 231.705H93.4841C93.5621 232.277 93.7788 232.732 94.1341 233.07C94.4981 233.408 94.9878 233.577 95.6031 233.577C96.1838 233.577 96.6301 233.43 96.9421 233.135C97.2541 232.832 97.4101 232.442 97.4101 231.965C97.4101 231.393 97.1848 230.96 96.7341 230.665C96.2921 230.362 95.6595 230.21 94.8361 230.21H94.5241V229.222H94.8361C96.4308 229.222 97.2281 228.689 97.2281 227.623C97.2281 227.155 97.0808 226.782 96.7861 226.505C96.4915 226.228 96.0841 226.089 95.5641 226.089C95.0441 226.089 94.6065 226.241 94.2511 226.544C93.8958 226.839 93.6878 227.276 93.6271 227.857H92.4701C92.5308 226.99 92.8298 226.314 93.3671 225.829C93.9131 225.335 94.6541 225.088 95.5901 225.088Z"
        fill={getPieceTextColor('43', props)}
        onClick={() => props.onPieceClick('43')}
      />
      <path
        d="M231.732 225.088C232.321 225.088 232.828 225.192 233.253 225.4C233.677 225.608 233.998 225.894 234.215 226.258C234.431 226.622 234.54 227.034 234.54 227.493C234.54 228.065 234.371 228.546 234.033 228.936C233.703 229.326 233.218 229.56 232.577 229.638V229.716C233.244 229.889 233.764 230.158 234.137 230.522C234.518 230.886 234.709 231.389 234.709 232.03C234.709 232.784 234.457 233.399 233.955 233.876C233.452 234.353 232.728 234.591 231.784 234.591C230.839 234.591 230.072 234.348 229.483 233.863C228.902 233.369 228.56 232.65 228.456 231.705H229.626C229.704 232.277 229.92 232.732 230.276 233.07C230.64 233.408 231.129 233.577 231.745 233.577C232.325 233.577 232.772 233.43 233.084 233.135C233.396 232.832 233.552 232.442 233.552 231.965C233.552 231.393 233.326 230.96 232.876 230.665C232.434 230.362 231.801 230.21 230.978 230.21H230.666V229.222H230.978C232.572 229.222 233.37 228.689 233.37 227.623C233.37 227.155 233.222 226.782 232.928 226.505C232.633 226.228 232.226 226.089 231.706 226.089C231.186 226.089 230.748 226.241 230.393 226.544C230.037 226.839 229.829 227.276 229.769 227.857H228.612C228.672 226.99 228.971 226.314 229.509 225.829C230.055 225.335 230.796 225.088 231.732 225.088ZM239.387 225.088C239.976 225.088 240.483 225.192 240.908 225.4C241.333 225.608 241.653 225.894 241.87 226.258C242.087 226.622 242.195 227.034 242.195 227.493C242.195 228.065 242.026 228.546 241.688 228.936C241.359 229.326 240.873 229.56 240.232 229.638V229.716C240.899 229.889 241.419 230.158 241.792 230.522C242.173 230.886 242.364 231.389 242.364 232.03C242.364 232.784 242.113 233.399 241.61 233.876C241.107 234.353 240.384 234.591 239.439 234.591C238.494 234.591 237.727 234.348 237.138 233.863C236.557 233.369 236.215 232.65 236.111 231.705H237.281C237.359 232.277 237.576 232.732 237.931 233.07C238.295 233.408 238.785 233.577 239.4 233.577C239.981 233.577 240.427 233.43 240.739 233.135C241.051 232.832 241.207 232.442 241.207 231.965C241.207 231.393 240.982 230.96 240.531 230.665C240.089 230.362 239.456 230.21 238.633 230.21H238.321V229.222H238.633C240.228 229.222 241.025 228.689 241.025 227.623C241.025 227.155 240.878 226.782 240.583 226.505C240.288 226.228 239.881 226.089 239.361 226.089C238.841 226.089 238.403 226.241 238.048 226.544C237.693 226.839 237.485 227.276 237.424 227.857H236.267C236.328 226.99 236.627 226.314 237.164 225.829C237.71 225.335 238.451 225.088 239.387 225.088Z"
        fill={getPieceTextColor('33', props)}
        onClick={() => props.onPieceClick('33')}
      />
      <path
        d="M108.184 249.394V248.406L112.89 242.27H114.164V248.367H115.516V249.394H114.164V251.5H112.968V249.394H108.184ZM113.046 243.713L109.432 248.367H113.046V243.713ZM116.389 250.59C117.862 249.602 119.041 248.623 119.925 247.652C120.809 246.673 121.251 245.763 121.251 244.922C121.251 244.402 121.116 243.986 120.848 243.674C120.588 243.353 120.163 243.193 119.574 243.193C118.967 243.193 118.508 243.388 118.196 243.778C117.884 244.159 117.71 244.688 117.676 245.364H116.506C116.566 244.341 116.883 243.557 117.455 243.011C118.027 242.456 118.763 242.179 119.665 242.179C120.523 242.179 121.203 242.409 121.706 242.868C122.208 243.327 122.46 243.977 122.46 244.818C122.46 245.511 122.234 246.218 121.784 246.937C121.342 247.648 120.783 248.311 120.107 248.926C119.439 249.533 118.75 250.048 118.04 250.473H122.694V251.448H116.389V250.59Z"
        fill={getPieceTextColor('42', props)}
        onClick={() => props.onPieceClick('42')}
      />
      <path
        d="M207.871 242.088C208.461 242.088 208.968 242.192 209.392 242.4C209.817 242.608 210.138 242.894 210.354 243.258C210.571 243.622 210.679 244.034 210.679 244.493C210.679 245.065 210.51 245.546 210.172 245.936C209.843 246.326 209.358 246.56 208.716 246.638V246.716C209.384 246.889 209.904 247.158 210.276 247.522C210.658 247.886 210.848 248.389 210.848 249.03C210.848 249.784 210.597 250.399 210.094 250.876C209.592 251.353 208.868 251.591 207.923 251.591C206.979 251.591 206.212 251.348 205.622 250.863C205.042 250.369 204.699 249.65 204.595 248.705H205.765C205.843 249.277 206.06 249.732 206.415 250.07C206.779 250.408 207.269 250.577 207.884 250.577C208.465 250.577 208.911 250.43 209.223 250.135C209.535 249.832 209.691 249.442 209.691 248.965C209.691 248.393 209.466 247.96 209.015 247.665C208.573 247.362 207.941 247.21 207.117 247.21H206.805V246.222H207.117C208.712 246.222 209.509 245.689 209.509 244.623C209.509 244.155 209.362 243.782 209.067 243.505C208.773 243.228 208.365 243.089 207.845 243.089C207.325 243.089 206.888 243.241 206.532 243.544C206.177 243.839 205.969 244.276 205.908 244.857H204.751C204.812 243.99 205.111 243.314 205.648 242.829C206.194 242.335 206.935 242.088 207.871 242.088ZM212.186 250.59C213.659 249.602 214.838 248.623 215.722 247.652C216.606 246.673 217.048 245.763 217.048 244.922C217.048 244.402 216.913 243.986 216.645 243.674C216.385 243.353 215.96 243.193 215.371 243.193C214.764 243.193 214.305 243.388 213.993 243.778C213.681 244.159 213.507 244.688 213.473 245.364H212.303C212.363 244.341 212.68 243.557 213.252 243.011C213.824 242.456 214.56 242.179 215.462 242.179C216.32 242.179 217 242.409 217.503 242.868C218.005 243.327 218.257 243.977 218.257 244.818C218.257 245.511 218.031 246.218 217.581 246.937C217.139 247.648 216.58 248.311 215.904 248.926C215.236 249.533 214.547 250.048 213.837 250.473H218.491V251.448H212.186V250.59Z"
        fill={getPieceTextColor('32', props)}
        onClick={() => props.onPieceClick('32')}
      />
      <path
        d="M141.006 259.394V258.406L145.712 252.27H146.986V258.367H148.338V259.394H146.986V261.5H145.79V259.394H141.006ZM145.868 253.713L142.254 258.367H145.868V253.713ZM148.834 253.44V252.335H151.46V261.5H150.212V253.44H148.834Z"
        fill={getPieceTextColor('41', props)}
        onClick={() => props.onPieceClick('41')}
      />
      <path
        d="M176.693 252.088C177.282 252.088 177.789 252.192 178.214 252.4C178.639 252.608 178.959 252.894 179.176 253.258C179.393 253.622 179.501 254.034 179.501 254.493C179.501 255.065 179.332 255.546 178.994 255.936C178.665 256.326 178.179 256.56 177.538 256.638V256.716C178.205 256.889 178.725 257.158 179.098 257.522C179.479 257.886 179.67 258.389 179.67 259.03C179.67 259.784 179.419 260.399 178.916 260.876C178.413 261.353 177.69 261.591 176.745 261.591C175.8 261.591 175.033 261.348 174.444 260.863C173.863 260.369 173.521 259.65 173.417 258.705H174.587C174.665 259.277 174.882 259.732 175.237 260.07C175.601 260.408 176.091 260.577 176.706 260.577C177.287 260.577 177.733 260.43 178.045 260.135C178.357 259.832 178.513 259.442 178.513 258.965C178.513 258.393 178.288 257.96 177.837 257.665C177.395 257.362 176.762 257.21 175.939 257.21H175.627V256.222H175.939C177.534 256.222 178.331 255.689 178.331 254.623C178.331 254.155 178.184 253.782 177.889 253.505C177.594 253.228 177.187 253.089 176.667 253.089C176.147 253.089 175.709 253.241 175.354 253.544C174.999 253.839 174.791 254.276 174.73 254.857H173.573C173.634 253.99 173.933 253.314 174.47 252.829C175.016 252.335 175.757 252.088 176.693 252.088ZM180.63 253.44V252.335H183.256V261.5H182.008V253.44H180.63Z"
        fill={getPieceTextColor('31', props)}
        onClick={() => props.onPieceClick('31')}
      />
      <defs>
        <filter
          id="filter0_d_3236_7662"
          x="83"
          y="199.5"
          width="60"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter1_d_3236_7662"
          x="114"
          y="206.5"
          width="62"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter2_d_3236_7662"
          x="63"
          y="181.5"
          width="57"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter3_d_3236_7662"
          x="46"
          y="157.5"
          width="58"
          height="57"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter4_f_3236_7662"
          x="67.7737"
          y="191.274"
          width="15.4526"
          height="18.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter5_d_3236_7662"
          x="29"
          y="127.5"
          width="67"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter6_f_3236_7662"
          x="50.7737"
          y="164.274"
          width="17.4526"
          height="20.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter7_d_3236_7662"
          x="13"
          y="82.5"
          width="76"
          height="79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter8_f_3236_7662"
          x="37.7737"
          y="121.274"
          width="26.4526"
          height="23.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter9_d_3236_7662"
          x="-1"
          y="-2.5"
          width="75"
          height="73"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter10_f_3236_7662"
          x="22.7737"
          y="33.2737"
          width="22.4526"
          height="29.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter11_d_3236_7662"
          x="4"
          y="38.5"
          width="74"
          height="77"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter12_f_3236_7662"
          x="29.7737"
          y="78.2737"
          width="18.4526"
          height="24.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter13_d_3236_7662"
          x="185"
          y="199.5"
          width="60"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter14_d_3236_7662"
          x="152"
          y="206.5"
          width="62"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter15_d_3236_7662"
          x="208"
          y="181.5"
          width="57"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter16_d_3236_7662"
          x="224"
          y="157.5"
          width="58"
          height="57"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter17_f_3236_7662"
          x="244.774"
          y="191.274"
          width="15.4526"
          height="18.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter18_d_3236_7662"
          x="232"
          y="127.5"
          width="67"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter19_f_3236_7662"
          x="259.774"
          y="164.274"
          width="17.4526"
          height="20.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter20_d_3236_7662"
          x="239"
          y="82.5"
          width="76"
          height="79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter21_f_3236_7662"
          x="263.774"
          y="121.274"
          width="26.4526"
          height="23.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter22_d_3236_7662"
          x="254"
          y="-2.5"
          width="75"
          height="73"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter23_f_3236_7662"
          x="282.774"
          y="33.2737"
          width="22.4526"
          height="29.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
        <filter
          id="filter24_d_3236_7662"
          x="250"
          y="38.5"
          width="74"
          height="77"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3236_7662" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3236_7662" result="shape" />
        </filter>
        <filter
          id="filter25_f_3236_7662"
          x="279.774"
          y="78.2737"
          width="18.4526"
          height="24.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_3236_7662" />
        </filter>
      </defs>
    </svg>
  );
}
